import type { JSX } from 'react';
import { Button, FormButtonRow } from '@ksyos/design-system';
import type { RedirectToSamlTaskType } from '@common/enums/redirectToSamlTaskType';
import { ProcessActivityStatus } from '@common/enums';
import { ProcessActivityEditCancelButton } from '@frontend/components/pages/episodeCategory/carePath/process/processActivity/processActivityEdit/ProcessActivityEditCancelButton';
import { useProcessActivityContext } from '@frontend/utils';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';

type RespiAllerButtonRow = Readonly<{
    label: string;
    taskType: RedirectToSamlTaskType;
}>;

export function RespiAllerEditButtonRow(props: RespiAllerButtonRow): JSX.Element | null {
    const { label, taskType } = props;
    const { patient } = usePatientEpisodeCategoryContext();
    const { processActivity } = useProcessActivityContext();

    if (processActivity?.status === ProcessActivityStatus.complete) {
        return null;
    }

    return (
        <FormButtonRow>
            <ProcessActivityEditCancelButton />
            <Button
                iconRight="external"
                onClick={() => (window.location.href = `/api/redirectToSamlTask/${taskType}/patients/${patient.id}`)}
                variant="solid"
            >
                {label}
            </Button>
        </FormButtonRow>
    );
}
